module.exports = __webpack_public_path__ + "static/media/Star.f2cd742d.svg";